import { isNil } from "lodash";
import colors from "PFTheme/tokens/colors";
import { useMemo } from "react";

import { WorkforceCalendarData } from "../../../context/booking_overview_context.types";
import { useBookingsOverviewContext } from "../../../context/bookings_overview_context";
import { useUtilizationDataProvider } from "../../../workforce_metrics";

export const useBackgroundColor = (
  value: number | undefined,
  isNonWorkingPeriod: boolean
): string | undefined => {
  const {
    calendarData: { thresholds }
  } = useBookingsOverviewContext<WorkforceCalendarData>();
  const { getBackgroundColor } = useUtilizationDataProvider();

  return useMemo(() => {
    if (isNonWorkingPeriod) {
      return colors.paletteWhite3;
    }
    const bgColor = !isNil(value) ? getBackgroundColor(value, thresholds.utilization) : undefined;
    return bgColor ?? colors.paletteWhite0;
  }, [value, isNonWorkingPeriod, thresholds.utilization, getBackgroundColor]);
};
